const DESCRIPTION_HAS_ACCOUNT = "bike:account_type.description_has_account"
const LABEL_HAS_ACCOUNT = "bike:account_type.label_has_account"
const LABEL_NO_ACCOUNT = "bike:account_type.label_no_account"
const LABEL_NO_FNUCI = "bike:account_type.label_no_fnuci"
const CAN_MODIFIED_EMAIL = "bike:account_type.can_modified_email"
const CANNOT_MODIFIED_EMAIL = "bike:account_type.cannot_modified_email"
const DESCRIPTION_CREATE_ACCOUNT = "bike:account_type.description_create_account"

// Les icones :
// iconLabel => s'affiche sur le bloc BikeStatusInformation, c'est-à-dire sur le bloc "vélo en service" (status du vélo)
// iconDescription => s'affiche sur le bloc FormBikeSold, c'est-à-dire sur le bloc "propriétaire du vélo"

export const bikeAccountTypes = [
    {
        id: "store", // statut 6
        suffix: "_STORE",
        label: "bike:account_type.label_store",
    },
    {
        id: "wallet_verified",
        suffix: "_WALLET_VERIFIED",
        label: LABEL_HAS_ACCOUNT,
        iconLabel: "check",
        description: DESCRIPTION_HAS_ACCOUNT,
        emailDescription: CANNOT_MODIFIED_EMAIL,
        iconDescription: "check",
    },
    {
        id: "wallet_not_migrated", // appartient à un wallet mais n’est pas migré (cas flotte)
        suffix: "_WALLET_NOT_MIGRATED",
        label: LABEL_NO_FNUCI,
        iconLabel: "warning",
        description: DESCRIPTION_HAS_ACCOUNT,
        emailDescription: CANNOT_MODIFIED_EMAIL,
        iconDescription: "check",
    },
    {
        id: "conso_account_not_verified", // Le propriétaire a bien un compte mais on ne sait pas s'il a ajouté le vélo
        suffix: "_CONSO_ACCOUNT_NOT_VERIFIED",
        label: LABEL_HAS_ACCOUNT,
        iconLabel: "check",
        description: DESCRIPTION_HAS_ACCOUNT,
        emailDescription: CAN_MODIFIED_EMAIL,
        iconDescription: "check",
    },
    {
        id: "conso_account_verified", // Le propriétaire a un compte
        suffix: "_CONSO_ACCOUNT_VERIFIED",
        label: LABEL_HAS_ACCOUNT,
        iconLabel: "check",
        description: DESCRIPTION_HAS_ACCOUNT,
        emailDescription: CANNOT_MODIFIED_EMAIL,
        iconDescription: "check",
    },
    {
        id: "nowallet_not_verified",
        suffix: "_NOWALLET_NOT_VERIFIED",
        label: LABEL_NO_ACCOUNT,
        description: DESCRIPTION_CREATE_ACCOUNT,
        emailDescription: CAN_MODIFIED_EMAIL,
    },
    {
        id: "nowallet_verified",
        suffix: "_NOWALLET_VERIFIED",
        label: LABEL_HAS_ACCOUNT,
        iconLabel: "check",
        description: DESCRIPTION_HAS_ACCOUNT,
        emailDescription: CANNOT_MODIFIED_EMAIL,
        iconDescription: "check",
    },
    {
        id: "nowallet_not_migrated",
        suffix: "_NOWALLET_NOT_MIGRATED",
        label: LABEL_NO_FNUCI,
        iconLabel: "warning",
        description: DESCRIPTION_CREATE_ACCOUNT,
        emailDescription: CAN_MODIFIED_EMAIL,
    },
    {
        id: "conso_not_verified", // Pas de compte
        suffix: "_CONSO_NOT_VERIFIED",
        label: LABEL_NO_ACCOUNT,
        description: DESCRIPTION_CREATE_ACCOUNT,
        emailDescription: CAN_MODIFIED_EMAIL,
    },
]